"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Landscape Design & Planting",
  description: "Thoughtful planting plans and landscape updates that bring structure, color, and a more polished look to your property.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/landscape_design_installation.png",
  aspect: "aspect-[3/4]"
}, {
  title: "Mulch & Garden Bed Refreshes",
  description: "Fresh mulch and cleaned-up garden beds that give your landscape a cleaner, more finished look.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/mulch_garden_bed_installation.png",
  aspect: "aspect-[3/5]"
}, {
  title: "Walkways & Hardscaping",
  description: "Custom walkways and hardscape elements that add structure, function, and a more finished feel to your outdoor space.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/walkways_hardscape_features.png",
  aspect: "aspect-[3/4]"
}, {
  title: "Shrub & Tree Planting",
  description: "Carefully selected shrubs and trees that add privacy, structure, and long-term beauty to your landscape.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/shrub_tree_planting.png",
  aspect: "aspect-[4/5]"
}, {
  title: "Lawn Care & Property Maintenance",
  description: "Routine mowing, edging, and upkeep that keeps your property looking neat, healthy, and consistently well maintained.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/landscape_maintenance.png",
  aspect: "aspect-[3/4]"
}, {
  title: "Seasonal Cleanup & Refresh",
  description: "Seasonal cleanups that remove buildup, refresh planting beds, and help your property look neat and ready for the season ahead.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/seasonal_cleanup.png",
  aspect: "aspect-[3/5]"
}];
export default function ServiceSpectrum() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section data-section-id="62284" id="our-professional-services" className="bg-background text-foreground py-24 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div ref={headerRef} className={cn("mb-16 max-w-2xl transition-all duration-1000 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-primary font-serif text-4xl md:text-5xl font-semibold tracking-tight mb-6">Our Landscaping Services</h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans leading-relaxed">From planting and lawn care to walkways, hardscaping, and seasonal cleanup, we offer the services homeowners count on to keep their property looking clean, polished, and well maintained.</p>
        </div>

        {}
        <div className="columns-1 md:columns-2 gap-6 space-y-6">
          {services.map((service, i) => <div key={i} data-index={i} className="break-inside-avoid">
              <Link to="https://landscaperswebsites.com/get-an-estimate/" className={cn("group relative block w-full overflow-hidden rounded-lg bg-card shadow-sm hover:shadow-xl transition-shadow duration-500", service.aspect)}>
                {}
                <img src={service.image} alt={service.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />

                {}
                <div className="absolute inset-0 bg-primary/20 transition-colors duration-500 group-hover:bg-primary/40" />

                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/40 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-95" />

                {}
                <div className="absolute inset-x-0 bottom-0 p-8 translate-y-12 transition-transform duration-500 ease-out group-hover:translate-y-0">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-white font-serif text-2xl md:text-3xl font-semibold">
                      {service.title}
                    </h3>
                    <span className="text-accent opacity-0 -translate-x-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0">
                      <ArrowUpRight className="h-7 w-7" />
                    </span>
                  </div>
                  
                  <div className="overflow-hidden">
                    <p className="text-white/90 font-sans text-base leading-relaxed opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100">
                      {service.description}
                    </p>
                  </div>
                </div>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}